export const FILM_ADMIN_REQUEST = "filmAdminReducer/FILM_ADMIN_REQUEST";
export const FILM_ADMIN_SUCCESS = "filmAdminReducer/FILM_ADMIN_SUCCESS";
export const FILM_ADMIN_FAILED = "filmAdminReducer/FILM_ADMIN_FAILED";
export const CHANGE_DIALOG_FILM_ADMIN_STATUS =
  "filmAdminReducer/CHANGE_DIALOG_FILM_ADMIN_STATUS";
export const FILM_ADMIN_EDIT = "filmAdminReducer/FILM_ADMIN_EDIT";
